export const getIframeContainerId = (iframeId: string): string =>
  `credit-card-iframe-${iframeId}`;
